import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
const initialState = {
  filterValues: {
    branchArray: [],
    branchValue: "",
    applicationArray: [],
    applicationValue: "",
    requestedDate: new Date(dayjs(new Date()).format("MM/DD/YYYY")),
  },
  touchHandler: {
    branchTouched: false,
    applicationTouched: false,
  },
  valueIsValid: {
    branchIsValid: false,
    applicationIsValid: false,
  },
};
const AmortCalculationReducer = createSlice({
  name: "amort",
  initialState: initialState,
  reducers: {
    updateBranchArray(state, action) {
      state.filterValues.branchArray = action.payload;
    },
    updateBranchValue(state, action) {
      state.filterValues.branchValue = action.payload;
      state.valueIsValid.branchIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updateApplicationArray(state, action) {
      state.filterValues.applicationArray = action.payload;
    },
    updateApplicationValue(state, action) {
      state.filterValues.applicationValue = action.payload;
      state.valueIsValid.applicationIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updateRequestedDate(state, action) {
      state.filterValues.requestedDate = action.payload;
    },
    //Reducer for touch handler
    updateBrachIsTouched(state, action) {
      state.touchHandler.branchTouched = action.payload;
    },
    updateApplicationNumberIsTouched(state, action) {
      state.touchHandler.applicationTouched = action.payload;
    },
    resetFilterValues(state, action) {
      state.filterValues.branchArray = [];
      state.filterValues.branchValue = null;
      state.filterValues.applicationArray = [];
      state.filterValues.applicationValue = null;
      state.filterValues.requestedDate = new Date(
        dayjs(new Date()).format("MM/DD/YYYY")
      );
    },
  },
});
export const AmortCalculationReducerAction = AmortCalculationReducer.actions;
export default AmortCalculationReducer.reducer;
